import { Flex, Typography } from '@banhala/ui-kit';
import { useAtomValue } from 'jotai';
import { Tooltip } from 'shared/src/component/Tooltip';
import { useMyPersonalizationForm } from '../state';
import IconHelpTooltip from './IconHelpTooltip';

type MySizeSectionProps = {
  tooltipDismissKey: number;
  onPressHeight: () => void;
  onPressWeight: () => void;
  onPressTop: () => void;
  onPressBottom: () => void;
  onPressShoes: () => void;
};

const TOOLTIP_TEXT =
  '입력해주신 정보는 다른 분들의 상품 사이즈 참고용으로만 제공되며 개인식별정보는 절대 공개되지 않습니다';

const MySizeSection = ({
  tooltipDismissKey,
  onPressHeight,
  onPressWeight,
  onPressTop,
  onPressBottom,
  onPressShoes,
}: MySizeSectionProps) => {
  const { formAtom, topLabelAtom } = useMyPersonalizationForm();
  const { height, weight, bottom, shoes } = useAtomValue(formAtom);
  const topLabel = useAtomValue(topLabelAtom);

  return (
    <Flex>
      <Flex.Row
        alignItems="center"
        padding={{ top: 24, bottom: 16 }}
        gap={4}
      >
        <Typography type="h5" color="content_primary">
          체형 정보
        </Typography>
        <Tooltip
          key={tooltipDismissKey}
          label={TOOLTIP_TEXT}
          contentStyle={{ maxWidth: 300 }}
        >
          <IconHelpTooltip size={24} />
        </Tooltip>
      </Flex.Row>

      <Typography type="body2" color="content_secondary">
        키와 체중을 선택해주세요
      </Typography>
      <Flex.Row gap={8} padding={{ top: 12 }}>
        <Flex flex={1}>
          <PropertyButton
            label="키"
            value={height != null ? `${height}cm` : null}
            onPress={onPressHeight}
          />
        </Flex>
        <Flex flex={1}>
          <PropertyButton
            label="체중"
            value={weight != null ? `${weight}kg` : null}
            onPress={onPressWeight}
          />
        </Flex>
      </Flex.Row>

      <Flex padding={{ top: 32 }}>
        <Typography type="body2" color="content_secondary">
          평소 입는 옷과 신발 사이즈를 선택해주세요
        </Typography>
      </Flex>
      <Flex.Row gap={8} padding={{ top: 12 }}>
        <Flex flex={1}>
          <PropertyButton
            label="상의 사이즈"
            value={topLabel}
            onPress={onPressTop}
          />
        </Flex>
        <Flex flex={1}>
          <PropertyButton
            label="하의 사이즈"
            value={bottom != null ? `${bottom}` : null}
            onPress={onPressBottom}
          />
        </Flex>
        <Flex flex={1}>
          <PropertyButton
            label="신발 사이즈"
            value={shoes != null ? `${shoes}` : null}
            onPress={onPressShoes}
          />
        </Flex>
      </Flex.Row>
    </Flex>
  );
};

type PropertyButtonProps = {
  label: string;
  value: string | null;
  onPress: () => void;
};

const PropertyButton = ({ label, value, onPress }: PropertyButtonProps) => {
  return (
    <Flex
      onPress={onPress}
      borderRadius={8}
      borderWidth={1}
      borderColor="border_secondary"
      height={80}
      alignItems="center"
      justifyContent="center"
      gap={4}
    >
      <Typography type="subtitle2" color="content_tertiary">
        {label}
      </Typography>
      <Typography
        type={value != null ? 'subtitle2' : 'body2'}
        color="content_blue_primary"
      >
        {value ?? '선택하기'}
      </Typography>
    </Flex>
  );
};

export default MySizeSection;
